function Profiles() {
	var self = this;
	
	$('body').on('click', '.submit-profiles-data', function(e){
		e.preventDefault();
		var form = $(this).closest('form');
		form.submit();
	});

	$(document).ready(function(){
		if ($('.edit-profile-form').length && $('div.error').length) {
			setTimeout(function(){ 
				$(window).scrollTop( $('div.error').first().offset().top - 120);
			}, 200);
		}
	});

}